import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3d538f89&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3d538f89&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d538f89",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d538f89')) {
      api.createRecord('3d538f89', component.options)
    } else {
      api.reload('3d538f89', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3d538f89&scoped=true&", function () {
      api.rerender('3d538f89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homeCard/supply/setting/index.vue"
export default component.exports